import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import tr from './translate/tr.json';
import en from './translate/en.json';

// localStorage'dan dil tercihini al
const savedLanguage = localStorage.getItem('language') || 'en';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            tr: {
                translation: tr
            },
            en: {
                translation: en
            }
        },
        lng: savedLanguage, // localStorage'dan alınan dil
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        }
    });

export default i18n; 